import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=b953331a&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=b953331a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b953331a",
  null
  
)

export default component.exports